module.exports = __webpack_public_path__ + "static/img/10032.dd2b8021.png";